import { url, modules, sysRole } from 'configs/';
import axios from 'axios';
import typeToReducer from 'type-to-reducer';
import { SUCCESS, FAIL } from 'containers/App/configureStore';
import { camelizeKeys } from 'humps';
import { isJsonString } from 'utils/index';
import * as rax from 'retry-axios';

const {
  SECURITY,
  NEWTUBE_API_SERVER,
  NEW_XE_API_SERVER,
} = url;

const NAMESPACE = 'tube/app/user/';
const FETCH_USER_DATA = `${NAMESPACE}FETCH_USER_DATA`;
const PUT_IDNUMBERVERIFY = `${NAMESPACE}PUT_IDNUMBERVERIFY`;
const TOGGLE_MODULE_AUTH = `${NAMESPACE}TOGGLE_MODULE_AUTH`;
const FETCH_USER_PERMISSION = `${NAMESPACE}FETCH_USER_PERMISSION`;

const moduleAuth = {};
for (const key in modules) {
  if (modules.hasOwnProperty(key)) {
    moduleAuth[`use${modules[key].authName}`] = false;
  }
}

const functionRole = {};
for (const key in sysRole) {
  if (sysRole.hasOwnProperty(key)) {
    functionRole[`is${sysRole[key]}`] = false;
  }
}

const initialState = {
  isLoaded: false,
  isVerify: false,
  isSupervisor: false,
  userDisplayName: undefined,
  moduleAuth,
  functionRole,
  employeeId: null,
  companyId: '',
  userRole: [],
  userPermission: [],
  isPermissionLoaded: false,
};

export default typeToReducer({
  [FETCH_USER_DATA]: {
    [SUCCESS]: (state, action) => {
      const response = isJsonString(action.payload.data) ? camelizeKeys(JSON.parse(action.payload.data)) : action.payload.data;
      const newModuleAuth = Object.assign({}, state.moduleAuth);
      const newFunctionRole = Object.assign({}, state.functionRole);
      sessionStorage.employee_id = response.data.employeeId;
      sessionStorage.company_id = response.data.companyId;

      response.data.userModule.forEach((moduleKey) => {
        if (modules[moduleKey] === undefined) {
          return;
        }
        newModuleAuth[`use${modules[moduleKey].authName}`] = true;
      });

      response.data.userRole.forEach((roleKey) => {
        if (sysRole[roleKey] === undefined) {
          return;
        }
        newFunctionRole[`is${sysRole[roleKey]}`] = true;
      });

      const newState = {
        userDisplayName: response.data.userName,
        isVerify: response.data.isVerify,
        isSupervisor: response.data.isSupervisor,
        moduleAuth: newModuleAuth,
        functionRole: newFunctionRole,
        isLoaded: true,
        allowModules: response.data.userModule,
        employeeId: response.data.employeeId,
        companyId: response.data.companyId,
        userRole: response.data.userRole,
      };

      return Object.assign({}, state, newState);
    },
  },
  [FETCH_USER_PERMISSION]: {
    [SUCCESS]: (state, action) => {
      return Object.assign({}, state, {
        userPermission: action.payload.data.data || [],
        isPermissionLoaded: true,
      });
    },
    // 失敗也要放行，否則 header 的模組列會因為等不到 permission 而一直不渲染
    [FAIL]: (state) => {
      return Object.assign({}, state, {
        userPermission: [],
        isPermissionLoaded: true,
      });
    },
  },
  [TOGGLE_MODULE_AUTH]: (state, action) => {
    const newModuleAuth = Object.assign({}, state.moduleAuth, {
      [`use${action.moduleName}`]: action.enable,
    });

    let newAllowModules = state.allowModules.slice();
    if (action.enable) {
      newAllowModules = [...newAllowModules, action.moduleName];
    } else {
      newAllowModules = newAllowModules.filter(m => m !== action.moduleName);
    }

    return Object.assign({}, state, {
      allowModules: newAllowModules,
      moduleAuth: newModuleAuth,
    });
  },
}, initialState);

export function fetchUserData() {
  const client = axios.create({
    timeout: 10000,
  });

  client.defaults.raxConfig = {
    instance: client,
  };

  rax.attach(client);
  return {
    type: FETCH_USER_DATA,
    payload: client.get(`${NEWTUBE_API_SERVER}userInfo`, {
      raxConfig: {
        retry: 99,
        noResponseRetries: 99,
      },
    }),
  };
}

export function fetchUserPermissionData() {
  const client = axios.create({
    timeout: 10000,
  });

  client.defaults.raxConfig = {
    instance: client,
  };

  rax.attach(client);
  return {
    type: FETCH_USER_PERMISSION,
    payload: client.get(`${NEW_XE_API_SERVER}platform-api/api/user/permissions`),
    raxConfig: {
      retry: 99,
      noResponseRetries: 99,
    },
  };
}

export function toggleModuleAuth({ moduleName, enable } = {}) {
  return {
    type: TOGGLE_MODULE_AUTH,
    moduleName,
    enable,
  };
}
export function fetchAllUserInfo() {
  return fetchUserData();
}

export function logout(loginPath) {
  const locale = sessionStorage.locale;
  sessionStorage.clear();
  if (loginPath) {
    location.href = `${SECURITY}/account/logout?original_target=${encodeURIComponent(location.origin + loginPath)}&lang=${locale}`;
  } else {
    location.href = `${SECURITY}/account/logout?original_target=${encodeURIComponent(location.href)}&lang=${locale}`;
  }
  return true;
}

export function putIdNumberVerify(value) {
  return {
    type: PUT_IDNUMBERVERIFY,
    payload: axios.put(
      '/users/account/verify',
      {
        idNumber: value,
      },
      {
        baseURL: NEWTUBE_API_SERVER,
      }
    ),
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/reducers/userReducer.js
 **/